<template>
	<div class="uploadImagesContainer">
		<div class="file-upload-layout">
			<input
				class="file-upload-element"
				type="file"
				id="images"
				name="images"
				multiple
				ref="fileupload_input"
				@change="handleFileChange"
				:accept="acceptTypes"
			/>
		</div>
		<label
			v-if="images.length > 0"
			for="images"
			class="add-image-item bg-hover-warning border border-3 border-warning text-hover-white"
		>
			<i class="bi-plus fw-bold text-warning fs-3x"></i>
		</label>
		<div class="uploaded-images noScrollBar" v-if="images.length > 0">
			<template v-for="(image, index) in images" :key="index">
				<div
					v-if="!image.hidden"
					class="image-item animation animation-fade-in border border-1 border-gray-300"
				>
					<img
						:src="image?.file?.type?.startsWith('video/') ? defaultVideoImage : image.url"
						height="50"
						width="50"
						alt="Uploaded Image"
					/>
					<div v-if="uploading && index == indexImageUploaded" class="circle-progress">
						<circle-progress :percent="40" fillColor="#ffc700" />
					</div>
					<button v-if="!uploading" @click="deleteImage(index)">
						<span class="text-center text-white">&times;</span>
					</button>
				</div>
			</template>
		</div>
<!--		<div v-if="convertVideoLoader" class="m-3 spinner-border"></div>-->
	</div>
</template>

<script>
import { storage } from '@/firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import 'vue3-circle-progress/dist/circle-progress.css';
import CircleProgress from 'vue3-circle-progress';
// import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';
import { loadFile } from '@/components/utils.js'

export default {
	props: {
		tenant: 299,
	},
	components: { CircleProgress },
    // inject: ['ffmpeg'],
	data() {
		return {
			images: [],
			acceptTypes: '.jpg, .jpeg, .png, .3gp, .mp4',
			maxFileSize: 1024 * 1024 * 2,
			indexImageUploaded: null,
			ImageUploadedPercent: 0,
			uploading: false,
			urlImageUploaded: '',
			defaultVideoImage: loadFile('default-video-image.png'),
			// ffmpeg: new FFmpeg({ log: true }),
			convertVideoLoader: false,
		};
	},
    methods: {
		// Reset the file upload component, clearing errors and values
		reset(index = null) {
			if (index === null) {
				this.$refs.fileupload_input.value = '';
				this.images = [];
			} else {
				this.images[index].hidden = true;
			}
			this.emitImages();
		},
		async uploadImages(callback) {
			this.uploading = true;

			// Create an array to store promises for each upload operation
			const uploadPromises = this.images.map(async (item, index) => {
				return new Promise(async (resolve, reject) => {
					this.ImageUploadedPercent = 0;
					this.indexImageUploaded = index;
					const image = item.file;
					const now = new Date();
					const fileRef = `${image.name + now.getTime()}`;
					const path = `tenants/${this.tenant}/images/${fileRef}`;
					const pathVideo = `tenants/${this.tenant}/videos/${fileRef}`;
					const storageRef = ref(storage, image.type.startsWith('video/') ? pathVideo : path);
					const uploadImage = uploadBytesResumable(storageRef, image);

					uploadImage.on(
						'state_changed',
						(snapshot) => {
							const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
							this.ImageUploadedPercent = progress;
						},
						(error) => {
							console.error('Error uploading file:', error);
							reject(error);
						},
						async () => {
							// Upload completed, get download URL
							const downloadURL = await getDownloadURL(uploadImage.snapshot.ref);
							this.urlImageUploaded = downloadURL;
							const hidden = index !== 0;
							const type = image.type;
							callback(downloadURL, hidden, type);
							this.reset(index);
							resolve();
						},
					);
				});
			});

			try {
				// Wait for all promises to be resolved
				await Promise.all(uploadPromises);
				this.uploading = false;
				this.reset();
			} catch (error) {
				// Handle errors if any of the uploads fail
				console.error('Error during upload:', error);
				this.uploading = false;
				this.reset();
			}
		},
		async validateVideo(event) {
			const file = event;
			if (!file) return;
			this.convertVideoLoader = true;

			if (!this.ffmpeg.loaded) {
			    await this.ffmpeg.load();
			}

			try {
				// let stdout = '';
                // this.ffmpeg.on('log', (data) => {
                // 	if (data.type === 'stderr') {
                //         stdout += data.message;
                //     }
                // });

				const path = URL.createObjectURL(file);

				const fileName = file.name;
				const fileData = await fetchFile(path);
				const inputFileName = 'input.mp4';
				const outputFileName = 'output.mp4';

				const isWriteDone = await this.ffmpeg.writeFile(inputFileName, fileData);

				const exitCode = await this.ffmpeg.exec(['-i', inputFileName, outputFileName, '-f', 'mp4']);
				// const exitCode = await this.ffmpeg.exec(['-i', inputFileName, '-c:v', 'libx264', outputFileName]);

				const newFile = await this.ffmpeg.readFile(outputFileName);
				const blob = new Blob([newFile.buffer], { type: 'video/mp4' });
                this.convertVideoLoader = false;
				return {url: URL.createObjectURL(blob), file: new File([blob], "converted-video.mp4", { type: 'video/mp4' })}
			} catch (err) {
				console.error(err);
			}
		},
		async handleFileChange(event) {
			const files = event.target.files;

			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				const maxSize = 16 * 1024 * 1024; // 2 MB
				// Validate file type
				if (file.type.startsWith('video/')) {
					let format = file.type.split('/')?.[1];

					if (format !== 'mp4' && format !== '3gpp') {
						this.$store.commit('Toasts/addToast', {
							message: this.$t('Mp4 and 3gp only allowed'),
							type: 'error',
						});
						return;
					} else if (file.size > maxSize) {
						this.$store.commit('Toasts/addToast', {
							message: this.$t('Video limit allowed is', { size: maxSize }),
							type: 'error',
						});
						return;
					}
					// else {
					// 	let {url, file: file2} = await this.validateVideo(file);
					// 	this.images.push({ url, file: file2, hidden: false });
					// 	this.$refs.fileupload_input.value = '';
					// 	this.emitImages();
					// 	return;
					// }
				}
				if (!file.type.startsWith('image/') && !file.type.startsWith('video/')) {
					this.$store.commit('Toasts/addToast', {
						message: this.$t('Please upload only images and videos'),
						type: 'error',
					});
					return;
				}

				// Validate file size
				// if (file.size > this.maxFileSize) {
				//   alert("File size exceeds the allowed limit.");
				//   return;
				// }

				const reader = new FileReader();

				reader.onload = () => {
					this.images.push({ url: reader.result, file, hidden: false });
					this.$refs.fileupload_input.value = '';
					this.emitImages();
				};

				reader.readAsDataURL(file);
			}
		},

		deleteImage(index) {
			this.images.splice(index, 1);
			this.emitImages();
		},

		emitImages() {
			this.$emit('update:length', this.images.length);
		},
	},
};
</script>
<style scoped lang="scss">
@import './styles/fileupload.scss';
</style>
